/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Draft_Discard_TitleInputs */

const en_us2_draft_discard_title = /** @type {(inputs: Draft_Discard_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Discard this draft?`)
};

const pt_br2_draft_discard_title = /** @type {(inputs: Draft_Discard_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descartar este rascunho?`)
};

const es_419_draft_discard_title = /** @type {(inputs: Draft_Discard_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Descartar este borrador?`)
};

const pt_pt2_draft_discard_title = /** @type {(inputs: Draft_Discard_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Descartar este rascunho?`)
};

const fr_fr2_draft_discard_title = /** @type {(inputs: Draft_Discard_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abandonner ce brouillon ?`)
};

const de_de2_draft_discard_title = /** @type {(inputs: Draft_Discard_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Diesen Entwurf verwerfen?`)
};

const it_it2_draft_discard_title = /** @type {(inputs: Draft_Discard_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scartare questa bozza?`)
};

/**
* | output |
* | --- |
* | "Discard this draft?" |
*
* @param {Draft_Discard_TitleInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const draft_discard_title = /** @type {((inputs?: Draft_Discard_TitleInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Draft_Discard_TitleInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_draft_discard_title(inputs)
	if (locale === "es-419") return es_419_draft_discard_title(inputs)
	if (locale === "pt-PT") return pt_pt2_draft_discard_title(inputs)
	if (locale === "fr-FR") return fr_fr2_draft_discard_title(inputs)
	if (locale === "de-DE") return de_de2_draft_discard_title(inputs)
	if (locale === "it-IT") return it_it2_draft_discard_title(inputs)
	return en_us2_draft_discard_title(inputs)
});
export { draft_discard_title as "draft.discard_title" }